// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentReports_root__ApPp3 {
    padding: 15px 40px 90px 40px;
    height: 100vh;
    overflow: scroll;
    margin-right: auto;
    margin-left: auto;
    color: var(--color-font-10);
    font-size: 16px !important;
  }
  
  .PaymentReports_title__UHCB5 {
    display: flex;
    align-items: center;
  }
  
  .PaymentReports_icon__9rrlD {
    padding-right: 10px;
  }
  
  .PaymentReports_arrow_icon__CmpDQ {
    padding: 0px 20px;
    color: var(--color-theme-silver);
  }
  

  .PaymentReports_confirm_btn__qGzp0 {
    color: var(--color-theme-blue) !important;
    border: 1px solid var(--color-theme-blue) !important;
    width: 176px;
    height: 41px;
    font-weight: bold !important;
    margin-top: 30px !important;
    margin-right: 30px !important;
  }
  
  .PaymentReports_confirm_btn__qGzp0 a {
    text-decoration: none;
    color: var(--color-theme-blue);
  }
  
  .PaymentReports_confirm_btn__qGzp0:hover {
    color: var(--color-theme-white) !important;
    background-color: var(--color-theme-blue) !important;
  }
  
  .PaymentReports_confirm_btn__qGzp0:hover a {
    color: var(--color-theme-white) !important;
  }
  
  .PaymentReports_content_container__Zld3T {
    width: 600px;
    padding-bottom: 80px;
  }

  .PaymentReports_date_input_container__GbxaK{
    width: 176px !important;
    display: inline-block;
    margin-right: 30px;
  }

  .PaymentReports_description__t-Lbt{
    padding-bottom: 20px;
  }
`, "",{"version":3,"sources":["webpack://./src/@_pages/PaymentReports/PaymentReports.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;;EAGA;IACE,yCAAyC;IACzC,oDAAoD;IACpD,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,0CAA0C;IAC1C,oDAAoD;EACtD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB","sourcesContent":[".root {\n    padding: 15px 40px 90px 40px;\n    height: 100vh;\n    overflow: scroll;\n    margin-right: auto;\n    margin-left: auto;\n    color: var(--color-font-10);\n    font-size: 16px !important;\n  }\n  \n  .title {\n    display: flex;\n    align-items: center;\n  }\n  \n  .icon {\n    padding-right: 10px;\n  }\n  \n  .arrow_icon {\n    padding: 0px 20px;\n    color: var(--color-theme-silver);\n  }\n  \n\n  .confirm_btn {\n    color: var(--color-theme-blue) !important;\n    border: 1px solid var(--color-theme-blue) !important;\n    width: 176px;\n    height: 41px;\n    font-weight: bold !important;\n    margin-top: 30px !important;\n    margin-right: 30px !important;\n  }\n  \n  .confirm_btn a {\n    text-decoration: none;\n    color: var(--color-theme-blue);\n  }\n  \n  .confirm_btn:hover {\n    color: var(--color-theme-white) !important;\n    background-color: var(--color-theme-blue) !important;\n  }\n  \n  .confirm_btn:hover a {\n    color: var(--color-theme-white) !important;\n  }\n  \n  .content_container {\n    width: 600px;\n    padding-bottom: 80px;\n  }\n\n  .date_input_container{\n    width: 176px !important;\n    display: inline-block;\n    margin-right: 30px;\n  }\n\n  .description{\n    padding-bottom: 20px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PaymentReports_root__ApPp3`,
	"title": `PaymentReports_title__UHCB5`,
	"icon": `PaymentReports_icon__9rrlD`,
	"arrow_icon": `PaymentReports_arrow_icon__CmpDQ`,
	"confirm_btn": `PaymentReports_confirm_btn__qGzp0`,
	"content_container": `PaymentReports_content_container__Zld3T`,
	"date_input_container": `PaymentReports_date_input_container__GbxaK`,
	"description": `PaymentReports_description__t-Lbt`
};
export default ___CSS_LOADER_EXPORT___;
